import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
function SomethingWrong() {
  let navigate = useNavigate();
  const GoToHome = () => {
    navigate("/cart");
  };
  return (
    <div>
      <section className="payment-success-bg py-5 mt-5 mb-5">
        <div className="container px-3">
          <div className="row justify-content-center text-center">
            <div className="col-12 col-md-8 col-lg-6">
              <img
                src="https://store.icespice.com/assets/images/img-failed.png"
                className="img-fluid mb-4 mx-auto d-block"
                style={{ maxWidth: "100%", height: "auto", width: "80px" }}
                alt="Payment Failed"
              />
              <h1 className="heading-failed fs-5 fs-md-3 mb-3">
                Oops! Something Went Wrong. Try again.
              </h1>

              <button
                className="btnPrimary btn  w-md-75 mt-3"
                onClick={GoToHome}
              >
                Go to Cart
              </button>

              <p className="mt-4 small text-white-50">
                If amount is deducted from your account, please contact our
                customer support.
              </p>
              <p className="small">
                Email:&nbsp;
                <a
                  href="mailto:support@icespice.com"
                  className="text-decoration-underline text-light"
                >
                  support@icespice.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SomethingWrong;
